import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'MenuEdit',
  data: function data() {
    return {
      title: '',
      tableData: [],
      selectMenuId: null,
      editDisabled: false,
      propMenu: {
        title: '',
        name: '',
        icon: '',
        component: '',
        path: '',
        pid: '',
        hidden: '',
        location: ''
      },
      menuTyes: [],
      form: {
        menuId: null,
        component: '',
        hidden: null,
        icon: '',
        path: '',
        pid: null,
        title: '',
        type: null,
        name: '',
        jurisdiction: '',
        location: 'left'
      },
      rules: {
        component: [{
          required: true,
          message: '请输入组建路径',
          trigger: 'blur'
        }],
        hidden: [{
          required: true,
          message: '请输入是否显示',
          trigger: 'blur'
        }],
        path: [{
          required: true,
          message: '请输入访问路径',
          trigger: 'blur'
        }],
        pid: [{
          required: true,
          message: '请输入父级目录',
          trigger: 'blur'
        }],
        title: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请输入目录类型',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入组件名称',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    /**
    * 获取枚举的方法 created
    */
    initEunmData: function initEunmData() {
      this.getEnumList('menu_type');
    },
    getEnumList: function getEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.menuTyes = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    typeChange: function typeChange(op) {
      console.log(op);
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.menuId = null;
      this.form.component = null;
      this.form.hidden = null;
      this.form.icon = null;
      this.form.path = null;
      this.form.pid = null;
      this.form.title = null;
      this.form.type = null;
      this.form.name = null;
      this.selectMenuId = null;
      this.form.jurisdiction = null;
      this.form.location = 'left';
      this.editDisabled = false;
      this.initTableData();
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.menuId = data.menuId;
      this.form.component = data.component;
      this.form.hidden = data.hidden;
      this.form.icon = data.icon;
      this.form.path = data.path;
      this.form.pid = data.pid;
      this.form.title = data.title;
      this.form.type = data.type + '';
      this.form.name = data.name;
      this.selectMenuId = data.pid;
      this.form.jurisdiction = data.jurisdiction;
      this.form.location = data.location;
      this.editDisabled = true;
      this.initTableData();
    },
    updateApi: function updateApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.UPDATE_MENU(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    saveApi: function saveApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.SAVE_MENU(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    save: function save() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this4.form.menuId != null) {
            _this4.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this4.updateApi();
            }).catch(function () {
              _this4.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            if (_this4.form.type !== '0' && _this4.selectMenuId === null) {
              _this4.$message({
                message: '没有选择主菜单',
                type: 'error'
              });
              return;
            } else {
              _this4.form.pid = _this4.selectMenuId;
            }
            _this4.saveApi();
          }
        } else {
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    },
    appendMenus: function appendMenus(data) {
      if (data.layer === 3) {
        this.$message({
          message: '无法在添加子菜单',
          type: 'error'
        });
        return;
      }
      this.selectMenuId = data.id;
      this.$message({
        message: '已选择主菜单',
        type: 'success'
      });
    },
    recursionMenus: function recursionMenus(menus) {
      var childrens = [];
      for (var i = 0; i < menus.children.length; i++) {
        var menu = menus.children[i];
        var children = this.recursionMenus(menu);
        var menuJson = {
          id: menu.menuId,
          label: menu.title,
          type: menu.type,
          layer: menu.layer
        };
        if (children.length > 0) {
          menuJson.children = children;
        }
        childrens.push(menuJson);
      }
      return childrens;
    },
    initTableData: function initTableData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res, menus, i, menu, children, menuJson;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {};
              _context4.n = 1;
              return api.GET_MENU_LIST(par);
            case 1:
              res = _context4.v;
              menus = [];
              for (i = 0; i < res.body.length; i++) {
                menu = res.body[i];
                children = _this5.recursionMenus(menu);
                menuJson = {
                  id: menu.menuId,
                  label: menu.title,
                  type: menu.type,
                  layer: menu.layer
                };
                if (children.length > 0) {
                  menuJson.children = children;
                }
                menus.push(menuJson);
              }
              _this5.tableData = menus;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  },
  created: function created() {
    this.initEunmData();
  }
};